import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import './checkout-button.scss';

type CheckoutLabel = `BUTTON.CHECKOUT` | 'SCROLLABLE_AREA.REVIEW_ORDER';

interface CheckoutButtonProps {
    label?: CheckoutLabel;
    disabled?: boolean;
    onCheckoutPressed: () => void;
}

const CheckoutButton = ({
    label = 'BUTTON.CHECKOUT',
    onCheckoutPressed,
    disabled,
}: CheckoutButtonProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Button className="checkout-button" type="primary" disabled={disabled || false} onClick={onCheckoutPressed}>
            {t(label)}
        </Button>
    );
};

export default CheckoutButton;
